import { useQuery } from "@tanstack/react-query";
import { getSupabaseWithLogging } from "@/lib/hooks/api/utils";
import { buildMinimalTicketsQuery } from "@wtc/supabase";
import { useTickets } from "./tickets-core-queries";

type FilterQueryParams = {
  page?: number;
  limit?: number;
  category?: string;
  assignedTo?: string;
  search?: string;
  clientId?: string;
};

export function useTicketsByStatus(status: string, params?: FilterQueryParams) {
  return useTickets({ status, ...params });
}

export function useTicketsByPriority(priority: string, params?: FilterQueryParams) {
  return useTickets({ priority, ...params });
}

export function useTicketSearch(searchTerm: string, clientId?: string) {
  return useQuery({
    queryKey: ["tickets", { search: searchTerm, clientId }],
    queryFn: async () => {
      const supabase = getSupabaseWithLogging();
      const query = buildMinimalTicketsQuery(supabase, { search: searchTerm, clientId });
      const { data, error } = await query;

      if (error) {
        console.error("Error searching tickets:", error);
        throw new Error(error.message);
      }

      return (data || []).map((ticket: { ticket_number?: number | null; [key: string]: unknown }) => ({
        ...ticket,
        formatted_ticket_number:
          ticket.ticket_number !== undefined && ticket.ticket_number !== null
            ? `WTC-${String(ticket.ticket_number).padStart(6, "0")}`
            : undefined,
      }));
    },
    enabled: !!searchTerm && searchTerm.length > 1,
    staleTime: 1 * 60 * 1000,
  });
}
